import { render, staticRenderFns } from "./DetalhesPix.vue?vue&type=template&id=30e37403"
import script from "./DetalhesPix.vue?vue&type=script&lang=js"
export * from "./DetalhesPix.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports